import React from 'react';

import { InfoBox, TitleWithDescription } from '@infoods/lifebase-ui';
import { Link } from '@mui/material';

import classes from './ContactCard.module.scss';
import { AvatarIcon } from '../ui-components';

type ContactCardProps = {
  title: string;
  name: string;
  nameDescription?: string;
  email: string;
  phone: string;
  avatar: string | null;
};

const ContactCard = ({
  title,
  name,
  nameDescription,
  email,
  phone,
  avatar,
}: ContactCardProps) => {
  return (
    <InfoBox title={title} variant="innerBox">
      <div className={classes.container}>
        <div className={classes.mainInfo}>
          <AvatarIcon userName={name} avatarImgLink={avatar} size="small" />
          <TitleWithDescription
            title={name}
            description={nameDescription}
            descriptionColor="main-black"
          />
        </div>
        <TitleWithDescription
          title="Email:"
          titleFont="body-14-bold"
          description={<Link href={`mailto:${email}`}>{email}</Link>}
          descriptionColor="main-black"
        />
        <TitleWithDescription
          title="Cell Phone:"
          titleFont="body-14-bold"
          description={<Link href={`tel:${phone}`}>{phone}</Link>}
          descriptionColor="main-black"
        />
      </div>
    </InfoBox>
  );
};

export { ContactCard };
